import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";

function Question(props) {
    return (
        <div className={props.color ? 'services_question bg_color p-100' : 'services_question p-100'}>
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="question_title">
                        <div className="example" data-text="FAQs">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="services_faqs">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    What types of mobile technology solutions can be managed through mobility management?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Mobile technology solutions that can be managed through mobility management include mobile apps, mobile devices (such as smartphones and tablets), mobile networks, and mobile data usage. A mobility management solution can help businesses to optimize these elements to meet their specific needs and goals.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    Can TekRevol help me with my mobility management needs?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Yes, TekRevol has a team of experienced professionals who are well-equipped to help businesses with their mobility management needs. We have a track record of success in developing and deploying mobile apps, managing mobile devices and networks, and optimizing mobile data usage for businesses of all sizes. Whether you're looking to improve productivity, increase efficiency, or better serve your customers and employees, we can help you create a custom mobility management solution that meets your needs.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Question;